import { ConditionalFunctionString } from '../../conditions.types'

// Exact string equality. Used for identifier-style values (currency codes,
// status enums, etc.) where substring matching isn't meaningful.
export const equalsText: ConditionalFunctionString = ({ property, value }) =>
  `${property} === ${JSON.stringify(value)}`

export const notEqualsText: ConditionalFunctionString = ({ property, value }) =>
  `${property} !== ${JSON.stringify(value)}`
